module.exports = __webpack_public_path__ + "assets/media/card-img-testimonial.c8368bc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoInstallStep/assets/card-img-testimonial.jpg
// module id = 3252
// module chunks = 0